import axios from 'axios';
import config from '../config';

// URL del endpoint para renovar el token
const refreshTokenEndpoint = 'Authentication/refreshToken';
const baseURL = config.REACT_APP_BASE_URL//process.env.REACT_APP_BASE_URL




let isRefreshing = false;
let subscribers = [];

// Agrega el token a las solicitudes
const apiClient = axios.create({
  baseURL
});

//! UTILIZAR TOKEN TYPE DEL LOCALSTORAGE

// Función para agregar el token a las cabeceras
apiClient.interceptors.request.use((config) => {

  const localAccessToken = localStorage.getItem('access-token')
  //console.log('localAccessToken es desde la request: ', localAccessToken)
  if (localAccessToken) {
    setupTokenRefresh();
    config.headers['Authorization'] = `Bearer ${localAccessToken}`;
  }

  //console.log('config: ', config)
  return config;
}, (error) => Promise.reject(error));



//MANEJO DE LA RENOVAVION DEL ACCESTOKEN CON EL FACTOR TIEMPO

// const setupTokenRefresh = async () => {

//   const localTokenExpiry = localStorage.getItem('expire-in')
//   const localRefreshToken = localStorage.getItem('refresh-token')
//console.log('localRefreshToken desde el timer: ', localRefreshToken)
//console.log('localTokenExpiry :', localTokenExpiry/1000)


//   if (!localTokenExpiry || !localRefreshToken) {
//     //console.log('No hay información de token disponible.')
//     return
//   }

//   const currentTime = Date.now()
//console.log('currentTime: ',currentTime/1000, 'tokenExpiry: ', parseFloat(tokenExpiry))

//   const timeUntilRefresh = parseFloat(localTokenExpiry) - (currentTime / 1000)


//   // 👉  Si el tiempo restante es muy corto (menos de 10 segundos), renueva inmediatamente
//   if (timeUntilRefresh <= 10) {
//     refreshAccessToken()
//   } else {
//     //console.log(`Programando renovación del accesToken en ${parseFloat(timeUntilRefresh).toFixed(2)} segundos`)
//     setTimeout(() => refreshAccessToken(), (timeUntilRefresh - 10) * 1000)
//   }

// }


//?Alternativa para el temporizador

let isTimerActive = false //👉 Variable global para controlar el temporizador

const setupTokenRefresh = async () => {
  const localTokenExpiry = localStorage.getItem('expire-in');
  const localRefreshToken = localStorage.getItem('refresh-token')

  if (!localTokenExpiry || !localRefreshToken) {
    //console.log('No hay información de token disponible.')
    return
  }

  const currentTime = Date.now();
  const timeUntilRefresh = parseFloat(localTokenExpiry) - currentTime / 1000

  //!👉 Evita configurar un nuevo temporizador si ya hay uno activo
  if (isTimerActive) {
    //console.log('Ya hay un temporizador activo.')
    return
  }

  if (timeUntilRefresh <= 10) {
    refreshAccessToken()
  } else {
    //console.log(
    //   `Programando renovación del accessToken en ${parseFloat(
    //     timeUntilRefresh
    //   ).toFixed(2)} segundos`
    // );
    isTimerActive = true //👉 Indica que hay un temporizador activo
    setTimeout(() => {
      refreshAccessToken()
      isTimerActive = false //👉 Restablece la variable al completar
    }, (timeUntilRefresh - 10) * 1000)
  }
}


//?                                   

const refreshAccessToken = async () => {
  try {

    
    //console.log('refresh-token desde la peticion: ', localStorage.getItem('refresh-token'))

    const headers = {
      'Content-Type': 'application/json',  // Asegura el tipo de contenido JSON
      'Authorization': `Bearer ${localStorage.getItem('access-token')}`
    };
    //console.log('Intentando renovar el token antes de la expiración...')

    const response = await axios.post(`${baseURL}${refreshTokenEndpoint}`, { refreshToken: localStorage.getItem('refresh-token') }, { headers })


    if (response) {

      //console.log('respuesta del refreshToken', response)
      //👉 Asumiendo que recibes un nuevo token y tiempo de expiración con esta estructura
      const { accessToken, refreshToken, expiresIn } = response.data

      //👉 Se Calcula la nueva hora de expiración
      const newExpiryTime = Date.now() / 1000 + expiresIn

      //👉Se Guarda el nuevo token y tiempo de expiración en localStorage
      localStorage.setItem('access-token', accessToken)
      localStorage.setItem('expire-in', newExpiryTime)
      localStorage.setItem('refresh-token', refreshToken)


      //console.log('Token renovado con éxito:')

      //👉 Si la peticion a refreshTokenEndpoint no arroja un error Programa el siguiente intento de renovación
      setupTokenRefresh()
    }

  } catch (error) {
    //console.log('error arrojado desde refreshAccessToken():', error)
    // localStorage.setItem("authStatus", 'unauthorized')
    localStorage.removeItem("authStatus")
    window.location.href = '/login'
    // throw error

  }
}


//MANEJO DE LA RENOVAVION DEL ACCESTOKEN CON LA RESPUESTA DEL SERVIDOR

// Manejo de respuestas 
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    //console.log('error.config', error.config)
    const originalRequest = error.config;

    // Si el error es 401 (token expirado)
    if (error.response?.status === 401 && !originalRequest._retry) {
      //console.log('error.response: ', error.response)

      if (isRefreshing) {
        //console.log('Ya se está refrescando el token, esperando...');

        return new Promise((resolve, reject) => {
          // Verificar si hay suscriptores esperando
          //console.log('Suscriptores pendientes:', subscribers.length);

          subscribers.push((token) => {
            //console.log('Recibiendo nuevo token:', token);

            // Actualizando el header con el nuevo token
            originalRequest.headers['Authorization'] = `Bearer ${token}`;
            //console.log('Nuevo header de autorización:', originalRequest.headers['Authorization']);

            // Resolviendo la promesa y enviando la solicitud original
            apiClient(originalRequest)
              .then((response) => {
                //console.log('Respuesta de la solicitud reintentada:', response);
                resolve(response);
              })
              .catch((error) => {
                // console.error('Error al realizar la solicitud reintentada:', error);
                reject(error);
              });
          });
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const headers = {
          'Content-Type': 'application/json',  // Asegura el tipo de contenido JSON
          'Authorization': `Bearer ${localStorage.getItem('access-token')}`
        };
        const refreshToken = { refreshToken: localStorage.getItem('refresh-token') };

        const response = await axios.post(`${baseURL}${refreshTokenEndpoint}`, { refreshToken },{headers});
        //console.log('Respuesta del servidor: ', response);
        const newAccessToken = response

        localStorage.setItem('access-token', newAccessToken);

        isRefreshing = false;
        subscribers.forEach((callback) => callback(newAccessToken));
        subscribers = [];

        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
        return apiClient(originalRequest)


      } catch (error) {
        // console.error('refreshError: ', error)
        localStorage.removeItem("authStatus")
        window.location.href = '/login';
        isRefreshing = false;
        subscribers = [];
        //console.log('Promise.reject(error): ',Promise.reject(error))
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
